module.exports = __webpack_public_path__ + "img/circle-plus-green.60c5b941.svg";